export default __webpack_public_path__ + "static/media/passport_foundersedition_web_resize.6a7b0828.png";